import { render, staticRenderFns } from "./pointer.vue?vue&type=template&id=f2fcc4d4&scoped=true&"
import script from "./pointer.vue?vue&type=script&lang=js&"
export * from "./pointer.vue?vue&type=script&lang=js&"
import style0 from "./pointer.vue?vue&type=style&index=0&id=f2fcc4d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fcc4d4",
  null
  
)

export default component.exports